import React, { PropsWithChildren, useContext } from 'react'
import { useBooleanState } from '@oneblink/apps-react'

type THeaderButtonsContext = {
  isDraftButtonVisible: boolean
  showDraftButton?: () => void
  hideDraftButton?: () => void
}

const HeaderButtonsContext = React.createContext<THeaderButtonsContext>({
  isDraftButtonVisible: false,
})

export const useHeaderButtonsContext = function useHeaderButtonsContext() {
  return useContext(HeaderButtonsContext)
}

export default function HeaderButtonsProvider({
  children,
}: PropsWithChildren<Record<string, unknown>>) {
  const [isDraftButtonVisible, show, hide] = useBooleanState(false)

  return (
    <HeaderButtonsContext.Provider
      value={{
        isDraftButtonVisible,
        showDraftButton: show,
        hideDraftButton: hide,
      }}
    >
      {children}
    </HeaderButtonsContext.Provider>
  )
}
